module.exports = __webpack_public_path__ + "img/chevron_down_sm.svg";